
import { apiFetch } from "../utils/apiFetch"

// Service für alle EUIPO Goods & Services Routen.
// Kommuniziert mit unseren Backend-Routen für diese API.

export function getClassHeadings() {
  return apiFetch("/api/euipo/class-headings")
}

export function getTaxonomy() {
  return apiFetch("/api/euipo/taxonomy")
}

export function searchTerms(term: string | number) {
  const trimmed = String(term).trim()
  const params = new URLSearchParams()

  params.set("size", "10")

  const classNumber = Number(trimmed)

  if (
    /^\d+$/.test(trimmed) &&
    Number.isInteger(classNumber) &&
    classNumber >= 1 &&
    classNumber <= 45
  ) {
    params.set("classNumber", String(classNumber))
  } else {
    params.set("term", trimmed)
  }

  return apiFetch(`/api/euipo/terms?${params.toString()}`)
}

export function validateClassification(payload: any) {
  return apiFetch("/api/euipo/validate", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  })
}

export function translateClassification(payload: any) {
  return apiFetch("/api/euipo/translate", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  })
}

export function getSuggestions(payload: any) {
  return apiFetch("/api/euipo/suggestions", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  })
}

export function getTermsByClass(classNumber: string | number) {
  return apiFetch(`/api/euipo/terms-by-class/${classNumber}`)
}

export function getTermsByConcept(conceptId: string) {
  return apiFetch(`/api/euipo/terms-by-concept/${conceptId}`)
}

export function getTermsByParentConcept(conceptId: string) {
  return apiFetch(`/api/euipo/terms-by-parent/${conceptId}`)
}

export function checkTerms(classes: any) {
  return apiFetch("/api/euipo/check", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ classes })
  })
}

export interface TrademarkSearchParams {
  trademark?: string
  applicant?: string
  representative?: string
  NiceClasses?: string
  registrationNumber?: string
  applicationNumber?: string
  ViennaCode?: string
  image?: string
  status?: string
  page?: number
  size?: number
  sortBy?: string
  sortOrder?: "asc" | "desc"
}

export function searchTrademarks(params: TrademarkSearchParams) {
  const queryParams = new URLSearchParams()

  if (params.trademark) queryParams.append("trademark", params.trademark)
  if (params.applicant) queryParams.append("applicant", params.applicant)
  if (params.representative) queryParams.append("representative", params.representative)
  if (params.NiceClasses) queryParams.append("NiceClasses", params.NiceClasses)
  if (params.registrationNumber) queryParams.append("registrationNumber", params.registrationNumber)
  if (params.applicationNumber) queryParams.append("applicationNumber", params.applicationNumber)
  if (params.ViennaCode) queryParams.append("ViennaCode", params.ViennaCode)
  if (params.image) queryParams.append("image", params.image)
  if (params.status) queryParams.append("status", params.status)
  if (params.page !== undefined) queryParams.append("page", params.page.toString())
  if (params.size !== undefined) queryParams.append("size", params.size.toString())
  if (params.sortBy) queryParams.append("sortBy", params.sortBy)
  if (params.sortOrder) queryParams.append("sortOrder", params.sortOrder)

  return apiFetch(`/api/euipo/trademarks/search?${queryParams.toString()}`)
}

export function getTrademarkDetails(
  trademarkNumber: string,
  kind: "application" | "registration"
) {
  return apiFetch(`/api/euipo/trademarks/${kind}/${trademarkNumber}`)
}
